import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import QRCodeComponent from 'react-qr-code';
import { Box, Stack } from '@mui/material';

import AgTypography from '../../stories/Styles/AgTypography';
import { AgColor } from '../../stories/Styles/AgColor';

const QRCode = ({ value }: { value: string }) => {
  const messages = useIntl().formatMessage;
  const [isExpired, setIsExpired] = useState(false);
  const sevenDays = 1000 * 60 * 60 * 24 * 7;
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExpired(true);
    }, sevenDays);
    return () => clearTimeout(timer);
  }, [sevenDays]);

  if (isExpired) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        gap: 2,
        px: 2,
        py: 4
      }}>
        <AgTypography 
          contentStyle='AP.Paragraph.Large.SemiBold'
          message={messages({ id: 'QR_CODE_EXPIRED' })}
        />
        <AgTypography 
          contentStyle='AP.Paragraph.Medium.Regular'
          message={messages({ id: 'QR_CODE_EXPIRED_DESC' })}
          style={{ color: AgColor.grey6 }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      px: 2
    }}>
      <Stack direction='column' alignItems='center' justifyContent='center' gap={2}>
        <QRCodeComponent value={value} />
        <AgTypography 
          contentStyle='AP.Paragraph.Medium.Regular'
          style={{ color: AgColor.grey6 }} 
          message={messages({ id: 'EXPIRES_IN_7_DAYS' })} 
        />
      </Stack>
    </Box>
  );
};

export default QRCode;